export const navigations = [
  { name: 'All Members GSC', path: '/pages/allmembersGSC', icon: 'dashboard' },
  { name: 'Spot', path: '/pages/importsports', icon: 'dashboard' },
  { name: 'User Reports', path: '/pages/userreports', icon: 'dashboard' },
  { name: 'Club', path: '/pages/cluballaccess', icon: 'dashboard' },
  { name: 'Deletion Requests', path: '/pages/deletionrequests', icon: 'dashboard' },
  { name: 'Businesses', path: '/pages/businesses', icon: 'dashboard' },
  { name: 'Sponsors', path: '/pages/sponsors', icon: 'dashboard' },
  { name: 'Vouched Members', path: '/pages/vouchusers', icon: 'dashboard' },
  
];
